var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"header__container br_tl-2 br_tr-2 pa-3 hidden-sm-and-down relative",attrs:{"fluid":""}},[_vm._t("header-start"),_vm._t("header-end")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }